















































































import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import { CrudService } from '@/data/services/crud.service';
import { Veicolo } from '@/data/models/veicolo.model';
import { Search, SortDirection } from '@/data/models/search.model';

@Component
export default class VeicoloList extends Vue {
	@Prop({ default: true }) editable!: boolean;
	@Prop({ default: false }) checkboxable!: boolean;
	@Prop({ default: () => [] }) selected!: Veicolo[];
	
	@Inject('CrudService') crudService!: CrudService<Veicolo>;

	rows: Veicolo[] = [];
	loading: boolean = false;
	advancedSearch: Search = new Search('vehicle');
	checkedRows: Veicolo[] = [];

	constructor() {
		super();
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
	}

	loadVeicoli() {

		const datareq = this.crudService.searchEntities(
			Veicolo,
			'vehicle',
			this.advancedSearch,
			this.advancedSearch.page
		);
		const countreq = this.crudService.countEntities(
			Veicolo,
			'vehicle',
			this.advancedSearch
		);

		this.loading = true;
		Promise.all([datareq, countreq])
			.then((results) => {
				this.rows = results[0];
				this.advancedSearch.page.setTotal(results[1].ct);
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			})
			.finally(() => (this.loading = false));
	}

	editVeicolo(item: Veicolo) {
		this.$emit('edit', item);
	}

	openVeicolo(item: Veicolo) {
		this.$emit('open', item);
	}

	deleteVeicolo(item: Veicolo) {
		this.$emit('delete', item);
	}

	onPageChange(page: number) {
		this.advancedSearch.page.setPageNumber(page - 1);
		this.loadVeicoli();
	}

	onSortChange(field: string, dir: string) {
		this.advancedSearch.setSortField(field);
		this.advancedSearch.setSortDirection(dir);
		this.loadVeicoli();
	}

}
